import { DynamicPricingStateContextProvider, StateBasedDynamicPricingPanel } from "@/components/organisms";

export const StateBased = () => {
  return (
    <DynamicPricingStateContextProvider>
      <StateBasedDynamicPricingPanel />
    </DynamicPricingStateContextProvider>
  );
};
